import styled from '@emotion/styled';

import { Button } from 'components/buttons';

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
}));

export const StartOverButton = styled(Button)(() => ({
  margin: 'auto auto',
}));
